// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1W87c","topBottomGutter":"Layout_topBottomGutter__28ry9"};